import { createFileRoute, redirect } from '@tanstack/react-router';

// Backward-compat: il dettaglio prodotto vive ora sotto Anagrafica.
export const Route = createFileRoute('/protected/_layout/products/_layout/$id')(
  {
    beforeLoad: ({ params }) => {
      throw redirect({
        to: '/protected/registry/products/$id',
        params: { id: params.id },
      });
    },
  }
);
